import { useEffect, useState } from "react";

import {} from "../../core/feature/store";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import bgTop from "../../assets/images/icon_burekol/danamon/bg-danamon-top.png";
import bgGradientTop from "../../assets/images/icon_burekol/danamon/bg-gradient-top.svg";
import danamonTopRight from "../../assets/images/icon_burekol/danamon/danamon-top-right.svg";
import bukaRekening from "../../assets/images/icon_burekol/danamon/buka-rekening.svg";
import getPrize from "../../assets/images/icon_burekol/danamon/get-prize.svg";
import contentTop from "../../assets/images/icon_burekol/danamon/content-top.png";
import danaProtection from "../../assets/images/icon_burekol/danamon/dana-protection.svg";
import ojk from "../../assets/images/icon_burekol/danamon/ojk.png";
import lps from "../../assets/images/icon_burekol/danamon/lps.png";
import tkiWhite from "../../assets/images/icon_burekol/danamon/logo-tki-white.svg";
import terms from "../../assets/images/icon_burekol/danamon/terms.svg";
import phone from "../../assets/images/icon_burekol/danamon/phone.png";
import dbank from "../../assets/images/icon_burekol/danamon/dbank-logo.svg";
import googlePlay from "../../assets/images/icon_burekol/danamon/google-play.svg";
import appStore from "../../assets/images/icon_burekol/danamon/app-store.svg";
import bgSlicer from "../../assets/images/icon_burekol/danamon/bg-slicer.svg";
import flyer1 from "../../assets/images/icon_burekol/danamon/flyer1.png";
import flyer2 from "../../assets/images/icon_burekol/danamon/flyer2.png";
import flyer3 from "../../assets/images/icon_burekol/danamon/flyer3.png";
import Slider from "react-slick";
import optimal from "../../assets/images/icon_burekol/danamon/icon-DCW-optimal.png";
import asuransi from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-asuransi.png";
import investasi from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-investasi.png";
import kartu from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-kartu-transaksi.png";
import pinjaman from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-pinjaman.png";
import simpanan from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-simpanan.png";
import syariah from "../../assets/images/icon_burekol/danamon/icon-DCW-personal-syariah.png";
import priviledge from "../../assets/images/icon_burekol/danamon/icon-DCW-priviledge.png";
import promo from "../../assets/images/icon_burekol/danamon/icon-promo-new.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { isAndroid, isIOS, isMacOs } from "react-device-detect";
import { androidOpenUrlInBrowser } from "../../config/AndroidBridge";

const BurekolMobileDanamon = () => {
  const listIcon = [
    {
      id: 1,
      src: simpanan,
      alt: "Simpanan",
    },
    {
      id: 2,
      src: pinjaman,
      alt: "Pinjaman",
    },
    {
      id: 3,
      src: kartu,
      alt: "Kartu Transaksi",
    },
    {
      id: 4,
      src: promo,
      alt: "Promo Danamon",
    },
    {
      id: 5,
      src: asuransi,
      alt: "Asuransi",
    },
    {
      id: 6,
      src: investasi,
      alt: "Investasi",
    },
    {
      id: 7,
      src: optimal,
      alt: "Danamon Optimal",
    },
    {
      id: 8,
      src: priviledge,
      alt: "Priviledge",
    },
    {
      id: 9,
      src: syariah,
      alt: "Syariah Personal",
    },
  ];

  useEffect(() => {}, []);

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginRight: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          display: "block",
          background: "transparent",
          marginLeft: 32,
          width: 24,
          height: 24,
          color: "white",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  function openApple(){
    window.open("https://apps.apple.com/us/app/d-bank-pro/id1532879177", "_blank")
  }

  function openAndroid(){
    window.open("https://play.google.com/store/apps/details?id=com.dbank.mobile", "_blank")
  }

  function generalButton(){
    if(localStorage.getItem("app_version")){
      if(isAndroid){
        androidOpenUrlInBrowser("https://play.google.com/store/apps/details?id=com.dbank.mobile")
      } else {
        window.open("https://apps.apple.com/us/app/d-bank-pro/id1532879177", "_blank")
      }
    } else {
      if(isIOS || isMacOs){
        window.open("https://apps.apple.com/us/app/d-bank-pro/id1532879177", "_blank")
      } else {
        window.open("https://play.google.com/store/apps/details?id=com.dbank.mobile", "_blank")
      }
    }
  }

  var settings = {
    dots: true,
    centerMode: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  return (
    <>
      {/* <div className="w-full relative">
          <div className="w-full relative" >
            <div className="w-full z-0">
                <img src={bgTop} alt="" />
            </div>
            <div className=" w-full flex justify-end p-4 z-10">
                <img src={danamonTopRight} className="" />
            </div>
          </div>
          <div className=" bg-gradient-to-b from-[#0F8481] to-[#F99636F2] h-5 ">

          </div>
        </div> */}
      <div className="w-full relative">
        <div className="w-full relative">
          <div className="w-full h-[935px] relative">
            <img
              src={bgTop}
              alt=""
              className="absolute inset-0 object-cover w-full h-full"
            />
          </div>
          <div className="w-full flex-col flex p-3 z-10 absolute top-0 ">
            <div className=" w-full flex justify-end  top-0 right-0">
              <img src={danamonTopRight} alt="" />
            </div>
            <div className=" w-full flex mt-6 justify-center ">
              <img src={bukaRekening} alt="" />
            </div>
            <div className=" w-full flex mt-4 justify-center ">
              <img src={getPrize} alt="" />
            </div>
            <div className=" w-full flex justify-center ">
              <img src={contentTop} alt="" />
            </div>
            <div className=" w-full flex justify-center -mt-16 ">
              <button onClick={ generalButton } className=" bg-[#FEB139] py-2 px-3 font-bold text-white rounded-xl ">
                Daftar Sekarang
              </button>
            </div>
            <div className=" w-full justify-around mt-5 flex flex-row ">
              <img src={danaProtection} alt="" />
              <img src={ojk} alt="" />
              <img src={lps} alt="" />
              <img src={tkiWhite} alt="" />
            </div>
            <div className=" w-full justify-around mt-5 flex flex-row ">
              <img src={terms} alt="" />
            </div>
          </div>
        </div>
        <div className=" -mb-2 w-full ">
          <img src={bgGradientTop} className="w-full" alt="" />
        </div>
        <div className=" bg-[#F99636] ">
          <div className=" font-black py-10 text-white text-5xl text-center ">
            MUDAHNYA TRANSAKSI DI APLIKASI D-BANK PRO
          </div>
          <div className=" w-full my-10 flex justify-center ">
            <img src={phone} alt="" />
          </div>
          <div className=" w-full mt-10 flex justify-center text-center text-white px-5 ">
            Nikmati kemudahan transaksi dan fitur banking lainya di Aplikasi
            D-Bank PRO
          </div>
          <div className=" w-full mt-2 justify-center flex flex-row ">
            <div className="mr-2">
              <img onClick={ generalButton } src={dbank} alt="" />
            </div>
            <div>
              <div className="mb-1">
                <button onClick={ generalButton } className=" bg-[#FEB139] py-1 px-3 font-bold text-white rounded-xl ">
                  Download Sekarang
                </button>
              </div>
              <div className="flex flex-row">
                <img onClick={ openAndroid } src={googlePlay} alt="" />
                <img onClick={ openApple } src={appStore} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className=" -mt-[1px] w-full ">
          <img src={bgSlicer} className="w-full" alt="" />
        </div>
        <div className=" w-full pt-20">
          <div className=" w-full text-center py-10 ">
            <div className=" font-black text-black ">E-Flyer</div>
            <div className=" text-black ">
              Penawaran Menarik dari Bank Danamon
            </div>
          </div>
          <div className="w-full">
          <Swiper
              slidesPerView={"auto"}
              centeredSlides={true}
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper"              
            >
              {[flyer1, flyer2, flyer3].map((d) => {
                return (
                  <SwiperSlide key={d}>
                    <div className=" w-full h-full items-center flex justify-center ">
                      <img src={d} alt="" />
                    </div>
                  </SwiperSlide>
                );
              })}              
            </Swiper>
            <style>
              {
                `.swiper-pagination-bullet{
                  width: 10px;
                  height: 10px;}`
              }
            </style>
            {/* <Slider {...settings}>
              {[flyer1, flyer2, flyer3].map((d) => {
                return (
                  <div key={d} className=" w-full flex justify-center ">
                    <img src={d} alt="" />
                  </div>
                );
              })}
            </Slider> */}
          </div>
        </div>
        <div className=" w-full pt-20">
          <div className=" w-full text-center py-10 ">
            <div className=" font-black text-black ">Product For Personal</div>
            <div className=" text-black ">Solusi Keuangan Pribadi</div>
          </div>
        </div>
        <div className=" w-full pb-20 px-10">
          <div className="grid grid-cols-3 gap-x-4 gap-y-3  mt-3">
            {listIcon.map((item, index) => {
              return (
                <button
                  key={index}
                  className="flex no-underline w-full justify-center"
                >
                  <div className="flex flex-col items-center gap-2.5 w-fit">
                    <div className="flex flex-col justify-center items-center w-[56px] h-[56px] rounded-2xl   bg-white active:bg-black shadow-md shadow-gray-300">
                      <LazyLoadImage
                        className="w-14 h-14 flex flex-col items-center p-2"
                        effect="blur"
                        src={item.src}
                      />
                    </div>
                    <p
                      className="font-montserrat  m-0 font-medium text-center text-psp-nav"
                      style={{ fontSize: 10 }}
                    >
                      {item.alt}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default BurekolMobileDanamon;
